import { useQuery } from '@tanstack/react-query';
import {
    Col,
    Flex,
    Grid,
    Layout, Modal, Row, theme,
    Typography,
} from 'antd';
import {
    CSSProperties, useEffect, useMemo, useState,
} from 'react';
import {
    Link, useLocation,
} from 'react-router-dom';

import { dashboardQueries } from '@/api/queries.api';
import { AppRoute } from '@/constants';
import {
    useUIStore,
    useUserStore,
} from '@/stores';

import { AppLogo } from './AppLogo';
import { ChangelogTable } from './ChangelogTable';
import { VersionOutput } from './VersionOutput';

const changelogModalStyles = {
    body: {
        padding: 0,
    },
};

export const AppFooter = () => {
    const { user } = useUserStore();
    const [showChangelogButton, setShowChangelogButton] = useState(false);
    const { data: onlineCount } = useQuery(dashboardQueries.getOnlineUsersCount());
    const [isChangelogModalOpen, setIsChangelogModalOpen] = useState(false);
    const { token } = theme.useToken();
    const screens = Grid.useBreakpoint();
    const isNarrowFooter = screens.lg === false;

    const footerLinkStyle: CSSProperties = useMemo(
        () => ({
            fontSize: token.fontSizeSM,
            width: isNarrowFooter ? '100%' : 130,
            maxWidth: '100%',
            display: 'block',
            textAlign: 'center',
        }),
        [isNarrowFooter, token.fontSizeSM],
    );
    const location = useLocation();
    const { setSupportTicketModalOpen } = useUIStore();
    const isChangelogPage = location.pathname === AppRoute.Changelog;

    const handleSupportTicketClick = () => {
        setSupportTicketModalOpen(true);
    };

    const handleChangelogClick = () => {
        setIsChangelogModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsChangelogModalOpen(false);
    };

    useEffect(() => {
        switch (user?.role) {
            case 'super_admin':
            case 'admin':
                setShowChangelogButton(true);
                break;
            default:
                setShowChangelogButton(false);
                break;
        }
    }, [user?.role]);

    return (
        <Layout.Footer style={{ backgroundColor: token.colorBgContainer }}>
            <Row gutter={[16, isNarrowFooter ? 16 : 0]} justify={isNarrowFooter ? 'center' : undefined}>
                <Col xs={24} lg={4}>
                    <Flex vertical justify="center" align="center" style={{ width: '100%' }}>
                        <Link to={AppRoute.Root}>
                            <AppLogo size="small" />
                        </Link>
                    </Flex>
                </Col>
                <Col xs={24} lg={16}>
                    <Flex vertical gap={10} justify="center" align="center" style={{ width: '100%' }}>
                        <Flex gap={isNarrowFooter ? 12 : 4} vertical align="center" style={{ width: '100%', maxWidth: isNarrowFooter ? 360 : undefined }}>
                            {/* Запит на підтримку — тимчасово приховано */}
                            {/* <Typography.Link
                                style={footerLinkStyle}
                                onClick={handleSupportTicketClick}
                            >
                                Запит на підтримку
                            </Typography.Link> */}

                            {showChangelogButton && !isChangelogPage && (
                                <Typography.Link
                                    style={footerLinkStyle}
                                    onClick={handleChangelogClick}
                                >
                                    Changelog
                                </Typography.Link>
                            )}

                            <VersionOutput />
                        </Flex>
                    </Flex>
                </Col>
                <Col xs={24} lg={4}>
                    <Flex vertical justify="center" align="center" style={{ width: '100%' }}>
                        <Typography.Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
                            Онлайн: {onlineCount ?? '—'}
                        </Typography.Text>
                    </Flex>
                </Col>
            </Row>

            {
                showChangelogButton ? <Modal
                    title="Changelog"
                    open={isChangelogModalOpen}
                    onCancel={handleCloseModal}
                    footer={null}
                    width={1200}
                    styles={changelogModalStyles}
                >
                    <ChangelogTable />
                </Modal> : ''
            }
        </Layout.Footer>
    );
};
